<div class="flex flex-col bg-card overflow-hidden">
  <div
    class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <div class="flex flex-col">
      <div
        class="font-bold text-md text-secondary uppercase tracking-wider"
        [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
      >
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto">
      @if (canEditPanelDef) {
        <button mat-icon-button type="button" [matMenuTriggerFor]="listCardMenu">
          <mat-icon
            class="icon-size-20"
            [svgIcon]="'more_vert'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <mat-menu #listCardMenu="matMenu">
          <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            <div
              mat-menu-item
              class="gap-2"
              *ngFor="let color of accountColors$ | async"
              (click)="selectHeaderColor(color.name)"
            >
              <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
              {{ color.label }}
            </div>
          </mat-menu>
        </mat-menu>
      }
    </div>
  </div>

  <div class="flex flex-col max-h-120 overflow-y-auto">
    <div class="w-full flex justify-end p-2 border-b">
      <app-column-selector
        [items]="fields$ | async"
        (onSave)="onSaveColumns($event)"
        [appAuthorize]="canEditDeal()"
      ></app-column-selector>
    </div>
    <div class="grid grid-cols-12 gap-x-1 pl-3" *ngIf="projectVersions$ | async as projectVersions">
      <div class="col-span-8 font-medium text-md text-secondary pt-2">FIELD</div>
      <div *ngFor="let item of projectVersions" class="font-medium text-md text-right text-secondary">
        {{ item.version_name }}
      </div>
      <div class="col-span-12 my-4 border-b"></div>
      <ng-container *ngFor="let row of displayColumns">
        <ng-container *ngIf="lookupField(row) as fieldDef">
          <div class="col-span-8 text-lg font-medium">{{ fieldDef.label }}</div>
          <div *ngFor="let item of projectVersions" class="self-center text-right">
            {{ item[fieldDef.name] | readableField: project : fieldDef : options }}
          </div>
          <div class="col-span-12 my-4 border-b"></div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
